import web_designer from "../../assets/web_design.svg"
import web_maintenance from "../../assets/web_maintenance.svg"
import graphic_design from "../../assets/Designer _Flatline.svg"
// import repairs from "../../assets/repairs.svg"
// import web_maintenance from "../../../assets/web_maintenance.svg"

export const cardData = [
    {
        "title": "Delivery Services",
        "desc": "Offering fast and dependable delivery solutions tailored to your logistics needs.",
        "image": web_designer,
    },
    {
        "title": "Car Hire",
        "desc": "Providing a wide range of vehicles for hire, suitable for both short-term rentals and long-term leases.",
        "image": web_maintenance,
    },
    {
        "title": "General Contract",
        "desc": "Delivering professional general contracting services across various industries and projects.",
        "image": graphic_design,
    },
];
